import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../services/api';
import { useApp } from '../context/AppContext';
import { Badge } from '../components/Badge';

export function OrgChart() {
  const { t } = useApp();
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    api
      .get('/api/employees')
      .then((r) => setEmployees(Array.isArray(r.data) ? r.data : []))
      .catch(() => setEmployees([]));
  }, []);

  const byArea = useMemo(() => {
    const map = new Map();
    employees.forEach((e) => {
      const area = e.area || 'General';
      if (!map.has(area)) map.set(area, []);
      map.get(area).push(e);
    });
    return [...map.entries()].sort((a, b) => a[0].localeCompare(b[0]));
  }, [employees]);

  return (
    <div className="page-stack">
      <p className="page-lead page-lead--tight">{t('orgChart.subtitle')}</p>

      {byArea.length === 0 ? (
        <div className="empty-state">{t('orgChart.empty')}</div>
      ) : (
        <div className="org-grid">
          {byArea.map(([area, people]) => {
            const managers = people.filter((p) => !p.manager_id || !people.some((x) => x.id === p.manager_id));
            const others = people.filter((p) => p.manager_id);
            return (
              <section key={area} className="panel org-block panel--elevated">
                <h2 className="panel__title">{area}</h2>
                <div className="org-columns">
                  <div>
                    <h3 className="org-sub">{t('orgChart.manager')}</h3>
                    {(managers.length ? managers : people.slice(0, 1)).map((p) => (
                      <div key={p.id} className="person-card person-card--lead">
                        <div className="person-card__avatar">{p.first_name[0]}</div>
                        <div>
                          <strong>
                            {p.first_name} {p.last_name}
                          </strong>
                          <div className="text-muted text-sm">{p.position}</div>
                          <Badge variant={p.status}>{t(`status.${p.status}`)}</Badge>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div>
                    <h3 className="org-sub">{t('orgChart.team')}</h3>
                    <div className="org-team">
                      {(others.length ? others : people).map((p) => (
                        <div key={p.id} className="person-card">
                          <div className="person-card__avatar subtle">{p.first_name[0]}</div>
                          <div>
                            <strong>
                              {p.first_name} {p.last_name}
                            </strong>
                            <div className="text-muted text-sm">{p.department || p.position}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            );
          })}
        </div>
      )}
    </div>
  );
}
